const blogTypes = {
  SET_CURRENT_MODULE: 'SET_CURRENT_MODULE',
  SET_CURRENT_LEVEL: 'SET_CURRENT_LEVEL',
  SELECT_SUB_MODULE: 'SELECT_SUB_MODULE',
  RESET_DEFAULT: 'RESET_DEFAULT',
  SET_ARTICLE_LIST: 'SET_ARTICLE_LIST',
  FETCH_BLOGS_SERVER: 'FETCH_BLOGS_SERVER',
  SET_BLOGS_FROM_SERVER: 'SET_BLOGS_FROM_SERVER',
};
export default blogTypes;
